<template>
  <div id="app" class="h-100">
    <router-view :key="$route.path" />
    <vue-snotify v-if="loading" />
    <notification-worker ref="notificationWorker"></notification-worker>
  </div>
</template>

<script>
import $bus from './_eventBus'
import NotificationWorker from '@/components/notifications/notification-worker.vue'

export default {
  name: 'App',
  components: {
    NotificationWorker
  },
  data: () => ({
    loading: true
  }),
  created() {
    $bus.$on('loading', (payload) => {
      this.loading = payload
    })
    $bus.$on('pushNotification', (payload) => {
      this.$refs['notificationWorker'].open(payload)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue